import React, { Component } from 'react';



const Data = [
	{
		icon:require('../Comp/img/gmailIcon.png'),
		b:"Gmail",
	}, 
	{
		icon:require('../Comp/img/chromeIcon.png'),
		b:"Chrome",
	}, 
	{
		icon:require('../Comp/img/gMapsIcon.png'),
		b:"Google maps",
	}, 
	{
		icon:require('../Comp/img/gClndIcon.png'),
		b:"Google Calendar",
	},
	{
		icon:require('../Comp/img/youtubeIcon.png'),
		b:"YouTube",
	},
	{
		icon:require('../Comp/img/googleSearchIcon.png'),
		b:"Google Search",
	}, 
	{
		icon:require('../Comp/img/gDocsIcon.png'),
		b:"Google Docs",
	}, 
]
const DATA = {
	chrome:"chrome_0",
	gmail:"gmail_1"
}

const Q = [
	"Do you know if there are other apps that provide similar functionality to __APP__?",
	"Have you tried any other app that provides similar functionality to __APP__?",
	"Do you currently use both __APP__ and another app that provides similar functionality to __APP__?",
	"If you wanted to use a different app with similar functionality to __APP__ - would it be easy for you to find one?",
	"If you wanted to use a different app with similar functionality to __APP__ - would it be easy for you to download and install it?",
	"Did you want your phone to come preinstalled with __APP__?"
]
const DEFAULT_VALUE = ""
// const DEFAULT_VALUE = "Yes"
export default class Head extends Component {
	state = {
		q0:DEFAULT_VALUE,
		q1:DEFAULT_VALUE,
		q2:DEFAULT_VALUE,
		q3:DEFAULT_VALUE,
		q4:DEFAULT_VALUE,
		q5:DEFAULT_VALUE,
	}
	componentDidMount() {
		this.report()
	}
	report() {
		const {k} = this.props
		const o = Data.filter(_ => _.b === k)[0]
		for(var q in this.state){
			const key = `${k.replace(" ", "_")}_${q}`
			global.setAnswer(key, this.state[q])
		}
	}
	reportAndCheckValidity() {
		this.report()
		let answered = 0;

		for(var q in this.state){
			if(this.state[q] != ""){
				answered++;
			}
		}

		const numItems = Object.keys(this.state).length;

		if(answered === numItems){
			global.setValid(true);
		}
	}

	render() {
		const {k,l,t} = this.props
		const o = Data.filter(_ => _.b === k)[0]
		return <div style={{
			position:"absolute",
			top:0,
			left:0,
			width: 360,
			height: global.isMobile ?  1434 : 1330,
		}}>		
			<div style={{
				position:"absolute",
				left: 24,
				top: 32,
				width:360 - 48,
				height:100,
			}}>
				<p style={{
					fontSize:16,
					color:"#BDBDBD"
				}}>A short survey</p>
			</div>
			<div style={{
				position:"absolute",
				left: 24,
				top: 96,
				width:360 - 48,
				height:65,
				// backgroundColor:"grey",
				alignItems:"center",
				display:"flex"
			}}>
				<img src={o.icon} style={{width:54, height:54}} />
				<span style={{
					width: 210,
					marginLeft: 20,
					fontSize: 18
				}}> Regarding the {k} App, please answer the following questions: </span>
			</div>
			{Q.map((q,i) => {
				return <div style={{
				position:"absolute",
				left: 20,
				width: 360 -40,
				height: 160,
				top: 180 + i * 180,
			}}>
				<p> {q.replace("__APP__", k).replace("__APP__", k)} </p>
				<div style={{
					position:"absolute",
					bottom: 30,
					left: 20,
					width: 100,
					display:"flex",
					alignItems:"center",
					cursor:"pointer"
				}} onClick={_ => {
					const c = {}
					c[`q${i}`] = "Yes"
					this.setState(c, this.reportAndCheckValidity);
					
				}}>
					<img src={this.state[`q${i}`] === "Yes" ? require("../Comp/img/radioOn.png") : require("../Comp/img/radioOff.png")} 
						style={{
							transform:"scale(0.5)"
						}}
					/>
					<span> Yes </span>
				</div>
				<div style={{
					position:"absolute",
					bottom: 30,
					right: 20,
					width: 100,
					display:"flex",
					alignItems:"center",
					cursor:"pointer"
				}} onClick={_ => {
					const c = {}
					c[`q${i}`] = "No"
					this.setState(c, this.reportAndCheckValidity);					
				}}>
					<img src={this.state[`q${i}`] === "No" ? require("../Comp/img/radioOn.png") : require("../Comp/img/radioOff.png")} 
						style={{
							transform:"scale(0.5)"
						}}
					/>
					<span> No </span>
				</div>
				<div style={{
					position:"absolute",
					bottom: 0,
					right: 0,
					width: 320,
					height:1,
					backgroundColor:"black",
					opacity:i=== q.length - 1 ? 0 : 0.2,
				}} />
			</div>})}
			
		</div>
	}

}



// WEBPACK FOOTER //
// ./src/gComp/G_app.js